var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.signed)?_c('li',{staticClass:"dd-m-menu__item dd-m-menu__item--logout"},[_c('a',{staticClass:"dd-m-menu__link",on:{"click":function($event){$event.preventDefault();return _vm.signOut()}}},[_c('i',{staticClass:"dd-m-icon icon-squares"}),_vm._v(" "),_c('span',[_vm._v("Sair")])])]):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-508838f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/site/js/components/auth/auth-logout.vue
// module id = 423
// module chunks = 2